import MapLoader from 'google-maps';
import turf from 'turf'
import pointToLineDistance from '@turf/point-to-line-distance'
import simplify from 'simplify-js'
import Tolls from '../../../services/toll'
import Route from '../../../services/route'
import {cents} from '../../../filters/number'
import inputAc from './input-google-ac.vue'

export default {
  data(){
    return {
      google: undefined,
      map: undefined,
      markers: [],
      axes: 1,
      directionsService: undefined,
      locationPoints: [{sequence: 1, type:'origin'}, {sequence: 2, type:'destination'}],
      viaPoints: [],
      qtdWayPoints: 0,
      msgError: undefined,
      loading: undefined,
      distance: undefined,
      qtdTolls: undefined,
      valueTolls: undefined,
      showSummary: false,
      coord: undefined,
      all: undefined,
      duration: undefined,
      result: {start: undefined, end: undefined, wayPoints: undefined, tolls: undefined,
              totalDistance: undefined, totalTime: undefined, totaltollFeeCost: undefined, allCovered: undefined},
      image: undefined,
      geocoder: undefined,
      restriction: undefined,
      teste: {a: "asdasd"},
    }
  },


  mounted(){
    $('[data-toggle="tooltip"]').tooltip();
    let vm = this;
    let mapPromise = vm.initMap();

    let tollsPromise = Tolls.getTolls().then(r => {

      this.all = r;
      this.tollsLoaded = true;
      //this.putPin(this.all);
    })

    let promise = Promise.all([mapPromise, tollsPromise]).then((result) => {
      vm.afterInit();
    }).catch(err => {

    });
    this.$store.dispatch('loading', promise);

  },

  watch: {
  },

  methods:{

    initMap(){
      let vm =  this;
      let promise = new Promise(function(resolve, reject) {
        MapLoader.KEY = 'AIzaSyAzAwCX1zCJ9idWkNdxs39j36N4lAToIjE';
        MapLoader.LIBRARIES = ['places'];
        MapLoader.load(function(google) {
          vm.google = google;
          vm.map = new google.maps.Map(document.getElementById('map'), {
            zoom: 4,
            center: {"lat":-21.009377008304,"lng":-48.17694799974561}
          });

          vm.directionsDisplay = new google.maps.DirectionsRenderer({
            draggable: true,
            suppressMarkers: true
          });
          vm.directionsDisplay.setMap(vm.map);

          vm.directionsService = new google.maps.DirectionsService();

          vm.directionsDisplay.addListener("directions_changed", function() {
            vm.updateNewDirections();
          });

          vm.restriction = new google.maps.LatLngBounds(new google.maps.LatLng(-57.325707, -89.222613), new google.maps.LatLng(18.480298, -33.537955));
          //vm.initAutoCompletes();
          resolve(true);
        });
      });
      return promise;

    },

    afterInit(){
      //Sobreescrever este metodo, sera chamado apos a lista com todos pedagios e o mapa tiverem iniciado por completo
    },

    afterUpdateDirections(){
      //Sobrescrever este metodo, sera chamado apos a rota estar completa com todos os pedagios
    },

    placeToPointLocation(place, sequence, type){
      let p = {
        type: type,
        sequence: sequence
      };
      _.each(place.address_components, function(o){
        if(_.indexOf(o.types, 'postal_code') >= 0)
          p.zipCode = o.short_name.replace(/[^0-9]/g, '');
        else if(_.indexOf(o.types, 'administrative_area_level_1') >= 0)
          p.state = o.short_name;
        else if(_.indexOf(o.types, 'administrative_area_level_2') >= 0)
          p.city = o.short_name;
        else if(_.indexOf(o.types, 'sublocality') >= 0)
          p.neighborhood = o.short_name;
        else if(_.indexOf(o.types, 'route') >= 0)
          p.address = o.short_name;
        else if(_.indexOf(o.types, 'street_number') >= 0)
          p.number = o.short_name;
        else if(_.indexOf(o.types, 'country') >= 0)
          p.country = o.short_name;
      });
      try{
        p.address = place.formatted_address;
        p.lat = place.geometry.location.lat();
        p.lng = place.geometry.location.lng();
      } catch(err){

      }
      return p;
    },

    // TODO remover
    plotar(){
      let pos = this.coord.trim().split(",");
      let marker = new google.maps.Marker({
        position: {lat: parseFloat(pos[0]), lng: parseFloat(pos[1])},
        icon: '/static/pins/pin-origin.png',
        map: this.map
      });

      let contentString = this.coord;

      let infowindow = new google.maps.InfoWindow({
        content: this.coord
      });

      marker.addListener('click', function() {
        infowindow.open(this.map, marker);
      });

      this.markers.push(marker);


    },

    initAutoCompletes(){

      var options = {
        //types: ['(regions)'],
        //componentRestrictions: {country: 'br'}
        strictBounds: true,
        bounds: this.restriction,
      };

      this.originAc = new google.maps.places.Autocomplete(document.getElementById('origin'), options);
      this.destinationAc = new google.maps.places.Autocomplete(document.getElementById('destination'), options);
      let vm = this;
      google.maps.event.addListener(this.originAc, 'place_changed', function () {

      });

    },
    putPin(tolls){
      _.each(tolls, (o) => {


          let marker = new google.maps.Marker({
            icon: o.id > 0 ? '/static/pins/pin-toll.png' : '/static/pins/pin-toll-inactive.png',
            position: o,
            map: this.map
          });

          let content = '';
          if(o.id < 0)
            content += `<div class="box-toll-map"><h4 class="title-toll">${o.description}</h4><span class="text-toll-inactive">Pedágio não atendido pela Move Mais.</span></div>`;
          else
            content += `<div class="box-toll-map"><h4 class="title-toll">${o.description}</h4><span class="text-toll">Valor do Pedágio: </span><span class="text-toll-value">${cents(o.price)}</span></div>`;

          let infowindow = new google.maps.InfoWindow({
            content: content
          });

          marker.addListener('click', function() {
            infowindow.open(this.map, marker);
          });

          this.markers.push(marker);

      });

    },

    setRouteMarkers(direction) {

      let legs = direction.routes[0].legs

      let start = legs[0].start_location;
      let marker = new this.google.maps.Marker({
        position: start,
        icon: '/static/pins/pin-origin.png',
        map: this.map
      });
      this.markers.push(marker);
      this.result.start = start;

      let end = legs[legs.length-1].end_location;
      marker = new this.google.maps.Marker({
        position: end,
        icon: '/static/pins/pin-destination.png',
        map: this.map,
        zIndex: 999,
        optimized: false
      });
      this.markers.push(marker);
      this.result.end = end;

      this.result.wayPoints = [];
      // coloca os WayPoints
      for(var i=1; i<legs.length; i++){

        let wayPoint = legs[i].start_location;

        this.result.wayPoints.push(wayPoint);
        let marker2 = new this.google.maps.Marker({
          position: wayPoint,
          icon: '/static/pins/pin-waypoint.png',
          map: this.map
        });

        let infowindow = new google.maps.InfoWindow({
          content: `<div>${legs[i].start_address}</div>`
        });

        marker2.addListener('click', function() {
          infowindow.open(this.map, marker2);
        });

        this.markers.push(marker2);

      }
    },

    updateNewDirections(){
        let vm = this;
        this.loading = new Promise(function(resolve, reject){
          vm.reset();

          if(vm.directionsDisplay.getDirections()){
            /*if(vm.directionsDisplay.getDirections().request.waypoints){
              vm.directionsDisplay.getDirections().request.waypoints.forEach(o => {

                if(o.stopover === false)

              });
            }*/
          }
          let tolls = vm.discoveryTolls(vm.directionsDisplay.getDirections());

          return Tolls.getPriceTolls({tolls: tolls.tolls, axes: vm.axes}).then(r => {
            tolls.tolls = r.tolls;
            vm.putPin(tolls.tolls);
            vm.result.tolls = tolls.tolls;
            vm.result.totaltollFeeCost = r.totalValue;
            vm.result.totalDistance = Math.round(tolls.totalRoute / 1000);
            vm.result.totalTime = tolls.totalDuration;
            vm.result.allCovered = r.allCovered;
            vm.setRouteMarkers(vm.directionsDisplay.getDirections());
            vm.showSummary = true;
            vm.afterUpdateDirections();
            resolve(true);

          });

        }).catch(err => {


        });

    },

    cleanMarkers(){
      for (var i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
      this.markers = [];

    },

    reset(){
      this.cleanMarkers();
    },

    calculate(){

      let vm = this;
      this.msgError = '';
      let promises = [];
      if(this.$refs.ac) {
        this.$refs.ac.forEach((o) => {
          promises.push(o.validate());
        });
      }
      return Promise.all(promises).then(res => {

        vm.msgError = undefined;
        vm.loading = new Promise(function(resolve, reject){});
        let origin = vm.locationPoints[0].address;
        let destination = vm.locationPoints[vm.locationPoints.length-1].address;

        let req = {
          origin: origin,
          destination: destination,
          travelMode: vm.google.maps.TravelMode.DRIVING
        };

        if(vm.locationPoints.length > 2){
          req.waypoints = [];
          for(var i=1; i<vm.locationPoints.length-1; i++){
            req.waypoints.push({location: vm.locationPoints[i].address});
          }
        }

        for(var i=0; i<vm.viaPoints.length; i++){
          if(!req.waypoints) req.waypoints = [];


          let c = vm.viaPoints[i].address.split(",");

          let latlng = new google.maps.LatLng({lat: parseFloat(c[0]), lng: parseFloat(c[1])});
          req.waypoints.push({location: latlng, stopover: false});
          //req.waypoints.push({lat: parseFloat(c[0]), lng: parseFloat(c[1]), stopover: false});
        }


        vm.directionsService.route(req, function(result, status) {



            if (status === vm.google.maps.DirectionsStatus.OK) {
              //
              if(origin != destination || vm.locationPoints.length > 2) {
                vm.directionsDisplay.setDirections(result);
              } else {
                vm.msgError = "Não foi possível calcular a rota, pois a origem e o destino são iguais.";
                vm.loading = Promise.reject(false);
              }

            } else {
              vm.msgError = "Não foi possível calcular a rota, tente especificar melhor a origem, o destino e os pontos de passagem (se existirem).";
              vm.loading = Promise.reject(false);
            }
        });

      }).catch(err => {
        this.msgError = 'Por favor verifique os endereços';
      });

    },

    showSavedRoute(points){
      //let simpl = simplify(points, 0.00001, false);
      //
      //
      //
      ///
let vm = this;
      let p1 = "|x}cC|{`eHDZb@dDHh@N~AN~AJ`BL~A??x@[v@]??d@~@b@~@j@jAj@hAl@nAn@lA??|@i@~@k@hBcAfAk@BA|Co@jCi@jCi@tCm@tCm@lAWjAYlAYfB[VEVEZK\\If@Kf@IDAvCm@d@Kr@O~A]|A_@r@OrCo@~@QjB_@~A]rAYrD{@p@Mr@MjDs@l@KvCo@dDs@pDw@fBa@dBc@??QyAS{A??vB^`BXf@FVBJDLD^RJDB@HDH@J@H?H?HANCDALALAL?L@L@L@zATn@H`@D`@DhAJ`CT`CRbCRRBRDPFRFNH??@@@@@@@@@@@@@?@@@@@?B@D@B?B?B?D?BAB?BA@A@??A@?@Ad@Ar@BvN~AzAXl@LPBNFPDNHLHLJLJ@@HJJLHNFNLR??Jh@^h@HLHHHJBBPNNHPJJDNBLBF@H@FBL@F?L?LCLCNEJELKLKJKJMHMHMHOTc@Zi@LQHOV_@HKFMDMDMB]?UPeALi@FSHUf@eAt@wA~@kBxAwCP[DIp@qAdA_BNWDG?A?CBQ??vAwB~BsDh@}@jDmFbDcFlB_DvAcC~CaFfC}D|BoDdEqGzF_JtFsI~BsDjCcEtAyBfEsG~DcGT[z@sAb@u@FKvD{FlAgBT_@Va@HMJQ@ANUfAcBZe@|AcCrB}CjAmB~BoDnCiE~DiGT_@dDgFfAcBrFqJd@y@dCkErA{BtGoK`HiKlAgBpCkEhAgBzAaCn`@mm@xEqHtSu[x@oAt@iAhAeBrAwBhAeBv@mAR]`@m@v@kAx@mAhDkFPWPWbC}DvCsE~K}PnW_a@bAaB`A{AtAuB\\i@`BgCj@{@tFuIPYT]zAiCRa@\\w@Xw@Tq@Pk@Lg@Je@Jg@Ji@N}@LcAD]B_@J{@JiAVsCHcADk@Hu@Ho@Hi@F[FYNw@J]J]Vu@Zu@P_@N[NYLSj@_AbAoAj@k@JKPQr@k@l@c@ZS|AgAJIJIxCyB~@q@b@]`@_@j@e@BAn@o@Z[j@o@X]d@o@PSV]Xa@Ze@`@m@zIeNbOeUrCsEbn@_`A~BoDbBkC|@sAHM@AFKfBoC|CwEjIkMnDsFz@sAvCuEfGiJjFgIjf@mu@pCcEFI|A}BNWfBqCVc@T]nCgExCuEhDkFpDwFbCuDzDaGxCuEtCoEbCuDdC}DdCuDfC{DlBuC~BsD|A_CxBkDpCiEjCaEzBiD`DcFjAgB|@uAbCuDfC{DfDkFrCkE|CyE|C{EtCmEzCyEvD}FhDiFpCgEpDuFdCwDpCmEbCuD|AeCj@{@rAoBj@}@zBkD@AJQJOzBoDl@{@z@sA~BmDb@q@fBoCvCsE@Cl@_A|@sAn@{@bLkQpAoBhBuCfC}DnB}CrAsBrAuBJM?AHMLQxBgDbBgClGqJjDuF`BcCxN{TxA_C|@uAvD{FxAyBdBoC~DiGzBkDbCeEzA}CtAeDv@iCp@_Ch@sBH[\\}AHg@RaA\\{An@sCR{@DO`@kBfAqF`AqElDePhAgFTeA~Lkk@tB{JjKqf@hK{e@|Ksh@l@}CjAoFt@mDLi@?ADSDU|BwKF[BMViAb@mBxJqd@tAoGLi@fCsLnHy\\pFoW~@gE`Lsh@d@yBxBaKnBoJJa@J_@VqAPu@DQb@uBXoArAaGpAuGHUFUZyAHe@Lo@Nw@Nw@hBuH|AwHz@eE`BeI^{AV{ALm@ZuAf@{B~@wDNm@Nm@Ja@F[^sAf@yAb@gAZw@Rg@R_@v@}AVa@Zg@@EzA_CXa@xC_EzB}C|@kAz@gADIn@y@h@u@dAwARU@CNShA_BlAgBb@e@`AuArCyDp@}@`@k@pDqEhCmD\\g@`AmATYj@u@V]h@u@fA{AlD{EDGFI|F{H~AyBLOvDeF@AbBwBjAcBrCyDBCjA_B|ByCT[b@k@n@s@n@i@RSTS^[pAcAz@m@xAw@j@Yt@_@^Ml@WlAa@hA[|Co@nAOvAOdBK~@CF?F?pAA^?nA@z@BN@bBP`CTB@bEd@fD^|APj@H`AJpD^zBRdCX`BPdBRlLjA`Hr@|@HfCXbJ|@fFl@`CVlC\\NB~C^v@Lx@HF@F?t@HtARxANjCXVDD?NBjD^jCVpO`B`AJrFf@vAHj@BZ?Z?f@AZ?\\CXA^E\\Ej@In@Kd@I`@I^Ml@SZMj@WhB_AhJgFxJqFhTsLr_@ySdP}IzHkEnIwE`CqAzSaLhAw@\\YVMzGwDTKPKhBcAZQ~JsFVO@?PK~@i@NI|BmAzA{@`E{BxZwPrAs@xBwAzGcEnFeDtCcBjAq@jEaClDmB`DgBhE_CRKnAs@nAs@tJmFrBiAhCwAnGmD|@a@|@i@x@g@|@e@xDwBpMiHpGmDjNyHxF}CpGoD`FmCrKaG|L{GxCcBnC{AtDsBfDiB~EmCbImEhAo@hAo@~EiC`@WDCh@[lGkDXQ|DuB@?nBiArC_BhCwArPgJrDoBFCf@Wj@[hAo@|Aw@bB{@pCcBhAq@`@Wj@Yv@e@f@Yl@]`By@rF{Cp@_@fNwH`B}@`CsAbDeBlEcCz@g@rCyA|CgB~CeB|FaDhBaA`Ai@rAo@|@_@nAe@xAg@xEcB~NcFtEaBhA_@~NeFzBw@hGsBvE_BjDoA~FsBjAa@rMqEhBo@zP_GjBq@nGyBvCcAxAg@vG{BzDuAPG~EcB^O@?h@QzBw@pBq@zDuAzBw@jGwBlHgClC}@|CgAvE_BhFiBhIqChIoC~Ak@vAe@hBo@nI{Cr@WrHiCxAi@nAc@r@WzNaFrDqArDqAdIqCbPuF`DiApC_ApAg@rAc@pFkBbA_@lC_AfA_@tAe@~HqCfBm@dA[vAa@~Cy@bEgAxC}@\\KpNcFzAi@pGyBZMnIuC~FqBnBu@j@Wp@[f@WfAm@bAq@j@_@lAaABCxAwA`AiAd@o@Za@RYb@o@d@{@f@_Ah@oANYRi@j@}AtA_Ej@aBdHiShHsSdHwShBeFjBgFzQii@|AqEb@qAfCsHtB}FfA_DrPcf@tScm@fCmHnEoMpCgIrCcIvCmIdCmHlBsFjAcDb@uAb@kAP_@Vi@^s@z@{AjBoCHOh@o@FI`AeAh@m@h@i@jAcAr@k@bBoA|@k@PKBAJGvAu@z@a@bAc@fAa@NEvAc@`B_@~@UpB]bC[hBOfBGzAAzA?dA@`AD`DJ`DJbl@rBnGTtCJzBJhFRx@?`@Ar@C`AOr@S|@a@`@SXQZUj@g@`DqCrGuFh@a@~AuA\\_@\\a@?APSNYPc@Pm@RgANs@Lq@F]H[J_@J[N_@Ta@PYRWRWRSNOXSXSh@[JEb@Qv@Yj@U\\M\\S\\YZ]T_@Xm@Ne@Ro@D]DYHaADWNs@Ja@Rg@d@cAFOXg@Zs@Rg@Na@?AJe@Ns@Dk@FaA?aACm@Ck@OaAc@mBoAyDGYG]Ga@Cg@?i@DcAJ_ArAoJt@gDLa@\\y@Ra@Te@Ze@TYz@{@bBkAr@e@dDsBlXiQdAq@XQDERKbAs@lBmApCiBt@e@nBoAr@_@LG|@]j@Qj@On@KvAQzD]zBQxBSzAKv@K|@Od@Mj@Qv@Yf@Up@]n@_@nC_BbGoDhO}I~FoDhCyAxCeBlAo@r@Yt@W\\KREf@O~H}AtEaA~LaCdGmA|@SRG^KHAb@SXM\\OTM\\S~@m@VUj@e@PQRSRURWv@eA\\m@Zm@LWPe@JYL]\\uALm@ReAF]H[La@Xw@LWHSTa@PYNURWPUTWTS\\Yp@g@`F}CTOf@Y|FsDpAw@ZOxA}@bTmMp@UZIzAWnBKrBFrDh@|BTRBdA@L@hACjC]ZI`@MpAk@rDcBfK_Fl@WpN}GdGuCdDyAlAa@NENGnCq@PEPEPCPEDAJCRCPCPCPCRAPCPAPARAP?RAP?PAjDGfK\\pKp@|@DzDRxC?dCUnBUfCs@tBw@bCqAd@[|AaAjEuCpDiCpEuCpCoBbCkB|AeAnA_Ar@m@~@cAb@c@dAgAdA_BP[z@_BjAeCTg@`@y@tD_IvD}HvAyCxA_DpD{HpBaEpAeC|AmCpAqBnA{A|AmBjBaCnKsLfEyEvQiSjHeI|AiBhCuCdAkAl@o@b@e@^c@f@i@l@o@|DgEVWLSLK@C`@g@TY`@e@p@{@jHcIjHcIdAkA|AeB|FsGd@c@lC}CDElBuBTW@?TYxCgD|@_AjD{DPQnDeEtDeE|EmF@CjE_FjE{ElE}Et@y@p@u@p@u@dEwEjF{FzEsEpE{DHIdA}@r@k@rAgATS^]LI@AVUHGl@g@^[|@u@hEkDXWj@e@p@i@p@k@ZYNMn@i@NMpJ{HdA}@z@s@TSHIFGpDyCd@_@`Aw@v@q@fA}@|@u@VSh@c@@Aj@c@tAmABCj@e@h@e@x@q@b@]j@g@ZW|@q@|@w@vBcBnAiAd@_@tAiAlB{A|@s@z@s@~@}@vFoE`G}EjBwAx@o@nA}@nBwAxA}@v@e@dAm@f@Y|@e@PKj@[z@a@l@Yp@[VKXIFCf@Wd@UjAe@\\OJEZOZKLGXKRKj@STMd@QXIHE`DsAlCgAnGmCtH{CpF}BVKdOiGrFyBrAi@pDyANGNGp@[`@O`@Q`@Q~Ao@hFuB`Aa@xAk@VMpBy@pD}AdCiA~BmArCsALG~@k@|IgFvA{@|B{AtByAxDoC@AxC}BzBiBXUfCsB`DsCvBoB`B_BdAeAhFsFhAqAdCsC`@g@b@i@pAaBpAcBrBoCbFkHrBwC|@wAz@wAz@wAx@yABEz@aBx@_Bx@aBv@aBVk@p@uAn@wABGvC{GRa@P]Na@@CL]Ti@N]HQ`@iA^iA^iA^iAvAqEn@qBh@gBh@gBnBgHt@yCz@oDf@_CZwAZqAh@oCTqANq@RaBLqAFy@F{@D{@Bs@?G?K?{B@g@?gA?qB?sBAsB?i@@{B?cHDwBLwB?ADcALiBNsBLkAZgC`@mCd@eCh@cCTaA~@gDb@uATw@Z}@`@uAp@oBBClEoNv@eCzDqLjAwDpDcLnBkGp@qBDO@CDKfBsFt@{BbA_DhByFj@eBFQFS@EdDgKfAoDfAiDp@cCb@mBjAoFx@sDjAiGzBgLd@sBnA_HpAiG~@yEf@cCXsAVyAt@uD|@kE|AeIz@cEpAmGJg@^iB@Gv@}D|@oEz@kE~Gk]Nk@Ls@vB{KtBkKr@sDzAiHHa@|AyH`A{EVsApAyGLk@d@_CF[Hg@FSBU|@iEJc@BKl@yCrCyNt@qDnCoNH_@H]Ls@rE_Ub@yB`D}NtDwRxE}Ur@mDr@sD`AsEfDcQvD{R|CiODQFWDYPy@H[v@eE~A_Il@aDp@gDjJge@lCyMbEqSdAyF@E@EZaBl@mCdIca@??`AmDRe@R]p@cAnAkAxE{Dr@e@n@[@An@Wr@Wh@MJEHGJE??tA]hA]zAe@bCq@f@MPEDAz@MTGTEp@OPEbAQRCj@Kj@Ip@Qx@S@?h@Qv@WDChAe@~Aw@zAu@PKn@]j@YRKXMp@Yj@W\\OZMbBo@RItCaAz@YdCw@f@O`@MhA[hA[z@UbAUrAYvA]r@Mp@Op@QrA_@rA_@p@Sr@Up@WnAe@nAi@|@a@|@a@h@Uh@Wf@Y`@WlAs@zA_Ab@WxCcBHEvBsAt@g@DC`@W`@WJGTO`Ak@tBsAzA}@nBmAxA}@zCkBrCcBzBsADE`CuANI~@k@`B}@JIh@_@l@a@j@]d@Y~@m@h@[|@m@~@k@vA}@jAs@z@i@XOl@_@dAo@`@Qn@_@bBcArCgB`CwAxA}@|CiBlCaBjDqBzEuCPOnDuBf@]^Wn@c@dBkArA{@|AcAd@]dAo@^URKd@Yd@WZUxDwBnC_BPK`BeAxA}@xA}@bDsBfCyA`@YdBeAtD_CpCaBXQ`@Y~@i@~FmDd@[vFmDlBeAl@[RKRKDA`CeAv@]TGfAa@r@SfA_@x@QzA]jCi@j@Kr@KnAOfAKhCUbBKh@Cj@Cr@AdAAX?rAA~AB\\@p@@`Sp@rI`@r\\bAxRt@j@Bx@@t@BfW|@tCJh@BhDJxAFlDL~CJtAFbDHtB?tCKb@CPAPArAMp@Iv@MhCe@bD}@tDcAjCs@tXuHtLeD~EsAhCu@dEkAdCs@jEmAvAc@bAYfA[|@W~@Y\\O^MjAm@n@_@l@c@j@g@`@]@Ab@c@b@c@bAwAz@_BXm@^{@pHmQl@kAP[b@s@n@eAp@cAr@_ABAt@y@v@{@x@y@tDmDLKj@g@JI@AHG`@a@j@k@n@o@n@m@\\[vAoAnAgAjAiAxJ}IpIyH`GqFvCmCxUoTrNwMpIcIxH_H|CgCx@w@tCaC|EqEdK_I|CeClIoGJGHEHGLIv@g@t@_@VMnAg@l@Sl@Qp@QxA[rEaAz@QjMmCvEgAzAYdD{@pGaBhDaApFcBNEbFyAdBk@`GsBvKuEzAo@|Ao@rAk@pAk@rAi@nF}BxCkArCkAhFiCdCyAdCyAbC}AxTyMTOPKtPeKzFkDp@a@f@Yd@Sz@a@z@[`A[`AYv@S|@QbAQ|@Mn@G`AGhBIhEG~CC|NQvLQbBApEHj@@pBDv@@tEHj[~@b@@X?j@Ap@Ah@A\\A~@I`AGv@Il@Id@Ip@Ol@Kh@Mn@Qp@Sh@Qt@Yf@Uj@UnBgArAy@fF{DzCaCbFyDbBuArBaBj@e@|EyDhEeD|CcChBwApB}AfBwAjBuAnAcAbAy@pAaAlB{AtAeAt@m@p@g@r@k@t@i@`Aq@bAo@lAs@lAq@nAo@jAg@z@_@`Bq@fBo@|Bu@x@U|Cw@zG}ADArAYrIgBxH_BpCm@hE_AlIeBjBa@dDq@rBc@hCk@zFkAv@Mv@ONEFA@?VGf@MFARGXIBA|By@tAm@tBgAt@i@nCsBJGPQ@AHIHIHGHIRSRSHKRSLMDEPUNSPUPUNSPWFIFKLQ@CNUT_@HMHOLSFMNWLYNYDKLYLYJYLYJ[DKTo@dAwClAkD`@iAv@wBN_@Ri@tAsDnSej@vAwD~BoGpAaDh@kAn@mARa@dB}CrCeE`@i@jAuAbAiAnCyCvAyA`CeCxB_CnLeMzEcFfEoEz@_AjAoAlBuB`AeA`BeBfBkB~@}@lCsChAgAd@k@NO`@c@`@c@DEDGLKBCNOPSd@i@pD{DFILI|HoIfGqGXYpBuBxAcBpAuAv@w@PQHIHIFGHIbAcA`HsHhDwDrAuAbBiBrCiDvAcB`CyClB_ChGsHl@s@hAsAj@s@`@e@h@o@p@{@`@k@~AmBpBkC~DkFPStAkBPWNQTYh@q@f@o@TYLMf@e@l@i@dBqAbAo@DE~@k@VKbHsCLGlFuBp@Yp@WfAe@`A_@`EaB~B_AdEaB~Aq@bMkFzBy@x@]vGqCfDqADA|QsHjAg@pGcCn@WLGJE?AVKjCgAjCgAxD{A`@QzIqD`CaAXKnBy@tBy@fAa@nCiApDaBzAs@l@Yl@]l@_@nH}F^[vCqCtEoELKJMrAkAhHaHdBcBBAlCiCJKFGDE@?lBiBdCcC|EeFxBeC^g@x@eAjA_B`B}BJObA{A`A_B~AeCd@_A`BcDfCgFP_@zAiDvAkDd@iAnCcGp@}AxAeD|@wBxAcDvEoKdC}FJUDMDGBG@ArBaFjFyLlFwLl@uAl@wApCoGdCwFlH}PvCqGhBeDl@aAjAmBpByCv@cAn@{@X[dBsBdBkBxAwAj@o@bFsE@ApFiFbC}B^]zBoBpBkBdB_B`@_@jBeBRS~DuDtFiFrEiEdD{CHI`@]PODE@ATSnAiAdD}Cl@k@xCqCrCmCjFcF~GcId@o@Zc@PWzCkEf@w@vAmCfB}Cj@eAv@uAlBiDzAkCVe@vAkCDIvAeCtAgC^s@r@uAr@qAvB_ExAmCb@w@j@eA@E|AwCNYxA}Cj@gAz@cBP_@|BwEn@wARe@Zq@P]bBkD^s@L[Vk@LUBEN[@?HQHQnAcCnBuDbAsBv@{A`@_Ax@eBbEoIDGfGiM|ByEx@}A??h@aAXc@`@k@f@o@`@e@\\a@VURSTSVUj@e@n@e@`@Y`@Ud@[b@Ud@WXM|Ao@^Mh@Ql@Qf@M|@SxAUf@Gn@IlAIrAItBKtEWtCQtIe@tCOPAXCt@Gz@E|@E~@G~@GdAGbAG|@G|@EfAGhAGf@CXA~@CB?v@CT?F?^?\\?h@A^?^?`B@f@@jAD`@B`@B`@BbCPfAL^D`@FZDD@^D\\F|@Nl@Jj@Lr@Nl@LvA^fAXdAZh@Rh@Rn@Rj@RpAb@|@Z`A\\~@Z~@\\hA^b@N`C|@FB|I|CZJXJt@VfKlDt@XrA`@hA^l@PzCv@fATzB\\lAN|Hh@dFFpa@BT?VAh@@h@?h@?T?h@?h@?h@?rAADAx@Av@Cd@Ef@Cd@Ed@Ed@Ef@GRCZC\\G\\ELCNC\\EZGNCLCrBa@vGoA|EgApBc@`B]`FeA`GsATEj@Oj@Oj@OTGj@Oj@OJEXIXIXKXKXKVKJEXKNITIVMJEJERKJEJERKBAPGRMTKRKTMRM^U~@k@~@k@ZQZSZSZUZSn@e@VQJGTOj@]h@S??~@g@jB_AfEeBtBq@x@W\\KDAb@Mb@Kd@Ib@Kn@KvFcAj@MbAQjCg@|GmApDq@dCc@rDm@hDm@`Dm@~@Q`AQ~@O`AOx@Mz@Mz@KdAMdAKdAKbAMjBQ|DSrEKzBCrGEzFCdFCfJEbJ?f@?dDEbDAvDArDChDC`DC`@AP?t@Cr@Ct@ERCVAt@Kd@GJAZG`@GHCl@Kv@Qp@QFCFADAt@SDA^OHCRG~Aq@VMXMXOz@g@|@i@ZSXSXSdAy@vLkJ`FyDdBsAnB}AnH{Fd@]b@]d@[d@[r@e@t@e@t@c@vA{@j@[h@Yj@YjAm@lAm@pCwAvDkBhB_Ax@a@tCyAfCoAbCmAdFgC`Bu@z@[pAa@f@Mj@Ml@MjBYtAOv@Et@C|@EpDGjFIhEGfBExFG|JUb@AD?vCElDEPAH?PAF?PAPAFAHAPANCFANCNEFAPCt@OHAREREHCHCREHCPGRGHCRIFCRIPGHEHCPKPIHEPIPKFERKFEPKNKNKFELKNKLMLKNMJKLM?A`AgAFKDEBEFM~@{AHKr@iAv@wAp@iA|AaChEeHzBiDp@cAr@{@v@_An@q@xAyAp@q@p@q@HGh@g@`Aw@vFkE~E{D|@s@vAgAf@_@n@g@DExC{Bt@m@pI}Gl@i@dC{BvA{AhAmArCsDjBqC|BoDl@aAJQNWlBwCr@mAtBcDnBcDfAgBhH_L|BqDl@}@l@}@|AyBlB_Cx@}@nEoEdCcClFuEnJqIvE_E|AoA`Au@bC_BZS\\SLG\\S\\Q^Sb@SDCLIPGZO\\QNG\\O\\O^O\\MtJsD~OeGxOcG`NgFxDyAZMZKXM|CuARKt@a@zA}@zAqAzBwBpBcCn@aA~A{ChCsF^aA`@aADOPa@BEHULY|BqFvAwCvCiFl@_AVa@nJaMJO|@qAvCyDxFoHxJeMzC}DjGkH`AcAjBmBX[V]Z_@BC^c@vIyIjE_E~E}DdAkAdAkAbAmA`AmA`AmA`AoA`AoA~@oAFKHKHKFKHKFKHKHKfAsA~@mAhBuBn@s@LQjEyE|GoH`DwDbMwMtEaF^c@@A\\_@NO\\a@\\c@^a@RSJM^_@^_@`@_@^_@`@]`@]b@]b@[`@]TMNKd@Yd@YFC@ApFgCrD_BfCkAlCoAdF_CpMcG^SdFaCjFoCtBkAl@_@`DoBnBuAlA{@fBoA|H_GbAu@bDaC`BmAv@k@TQNKFGBCBAFELILKbAq@ZQ\\Q\\QZQb@QVM^O^MZM^I^M^KFAdCk@`FaAbI_BLC^G^I\\I^I^K\\I^M\\K\\M^MNELGZM\\O\\OZOZO\\QZQZOdAo@b@YfAw@lA}@|D{CxEqDVUPODEHGNMXSzCaCvAgABCnDqCNKNMxC{BlEkDfDkCvIyGlBwArI}GpB_BxAmATSRUTSTURURURU`@c@V_@RUPWPW`@o@v@kAjAyBbA_ClAoCfBeEbAaCnCkFhAsB`BkC\\o@l@{@zBwCp@y@h@m@X[zCoD|CwDbIgJlHuIzBmCLMLOFIDELOx@aAv@_AX]X]pEmFrGwHbHiId@i@`@a@\\]f@e@d@_@`@]f@_@l@a@h@]f@YPKHERMt@]dAc@r@Wd@Qh@Od@MrA[tD{@lCm@pCo@xG{AhEgAd@QLEVKrB_AbAe@vAy@`BkAlAeAnBkBfAsAjBqC~AuCbCoFrAwCfSac@FOFM@?FQHQXq@|AcD|@cBr@sAvDcG`B{Bd@m@n@q@vBgC|A{AvAsAzCkCfCwB`CwBdEmDxAsA`FeEhB_BfF_FjCmCTUVYRSBCTWDGzEsFlEiF`@c@vUaXfAoAV[n@u@Z]vDmEdBmBFIp@u@DEj@o@pB{Bf@k@\\[d@e@f@g@bAcAvEcEfCsBdCiBTQdC_BJGxBsA@Aj@[j@[RKRMt@a@bB}@l@YzCyAtCkAbEyAhCw@nEqAtCs@hFsArGyA`Ci@rG{A`G{AvG{AHCHCFA@?JCFCHCHAHCFADAx@S~A_@lBe@|FwAbDu@vCs@xCs@`EcAHC|@SlAYnAYx@StFsA`RoEdFmAhCm@|A_@tD}@x@QjGyArA]hD{@vBm@lDgAjAa@h@S`@OZMb@Qt@[ZOv@]NGj@Y\\O\\Qj@Y\\Qp@_@hFcDdDaCtDwC\\]lDeDdAeATWHIJKRUTWHKJKJODEFIHIHIHIZ_@PUZ_@`@k@T[b@k@`@m@T[^m@`AuAh@y@jAcBxFoIlHqK`GwIT_@PUDGJORWPYvFeIdCsD`[id@jReYJOFGBEJOJOfBgCvDuFhEmGbCmD|@sAHKDGBCJQLQx@kArAkB~AwBhAuA~C{DlF{GbD_E^e@^c@d@k@b@i@hByBbAoAd@g@bBuBxAgBdE_F~DeEhAeAlAcAxDoC`CiBdBoA|AiAbBsAjBaBfCeCrB{B`@e@^g@T[t@cAp@}@HKtAmBvC{DtBsCxC{DBCnCyDfDgEn@w@f@i@d@c@hAaAf@a@b@[\\WhAq@jAk@bAe@xCaAfEkAfD}@vBm@fBi@|@Yh@WXKVK`@SNIFCXOPKXS`@UZU~@s@z@{@h@g@`@c@PS?ADET[HK\\g@DEJQ^k@n@eAfCmEFM~@}A`AiBh@cAj@iANUz@wAf@_A`AiBj@cALS\\i@`AcBjAgBv@gAv@}@x@{@jAaANOj@c@l@e@n@a@fAq@|@k@\\S`BaAhAu@z@m@p@c@zAqAtBmBRSJM`AmAHINOZa@d@m@v@eA`AoAvAkBtAkB`AmAtBqCr@aAPSl@o@VW^[x@i@@AfBcArBy@HCZKhAUz@MrAMdAG`VwAjGYtEU`CMxCO|AMtAOJAbB]v@Sf@Ql@Uf@SRKr@_@h@]`@Y^Yx@s@XWd@g@tAaBdBsBz@eApDqEn@q@d@e@VUNOBC`@[d@_@`@YTMPI\\URGb@Q^MNG`@K`@MVGPCVG\\G`@Eh@Gj@El@EtBKdJg@x@Ej@Cx@CnAId@Cj@Gn@Gh@Kh@K`ASVGNGNEn@Un@W\\Q\\Sz@g@bCmBdA}@d@e@^a@fHaH`KyJp@q@VWn@s@V[l@u@NSDGR]f@y@d@{@R]P_@^_AVs@v@}BrBiIpDsNT{@H]HYNg@Ri@Rg@NYRa@JQf@y@JMPWd@g@h@m@NKPKXQHGFE@AHGHGHGROHGHEHGJGHEHGLGJGHEJEHEVKHEJEVIJEHEJCVIJCJCJCJCJCJCJCJCJALCJCJAJAJCLAJAJAJAJALAJ?JAJAL?JAX?J?J?JAP@pEGv@?|AC@?xAAhE@hD@`BB~D@bBChCI~BKtEYpAEbBEzACxHE`KKhFIhB?t@At@C^An@An@ALCx@Kx@Ix@KjAQt@Mv@Mv@Ot@Qv@Qp@SpAc@pAe@rAg@HCp@YRIr@YDCh@Wn@]l@]l@_@j@a@l@a@j@a@j@e@XSXUPSRSx@aA^c@Za@p@u@v@}@r@s@p@u@l@m@@Av@w@^]ZWx@}@xA_Bn@m@fAeApAiAHIRUNOf@o@@ATSRSJKTSJIf@m@n@k@\\]hBmBDCp@u@p@u@`@c@NQjAsAR[l@y@|@kAx@_BHOHMf@y@n@kALUfAuCHSHWBK~@aEJm@VmBZ_Dh@_IXsEXyF`@oHf@wGhAiGt@sCl@aB|AoD~C_FjCgDdDeEtAwBbAuB`A_D|@oFd@aDp@aD\\sAZ_ATm@LYd@_Ab@u@v@gA^e@p@u@ZYh@e@b@[l@[t@_@\\Kv@Uh@Uv@W|@Uz@M`AOx@It@K~@MhAUr@GrAUxA[xAi@h@StAo@x@_@l@WfAi@dBcAvAs@~@c@pBiAdEqBfGyCdB}@fB}@PItAu@`EuBh@Sv@a@v@c@f@Yl@a@d@i@XYn@q@l@k@n@s@h@o@`@i@xAmB|B_DjHsJzBuCtAiBh@o@l@o@n@k@fA{@v@m@~A_Ah@W^S\\Mt@[v@Ul@Qn@Of@Mf@I^Gf@Gp@I^CpACRApCEhACxCCvDIfFKxDK~CE~@Ad@CtKg@vEYjPgAbF[dEUhCO|DQbEOpEIzCE??~CGf@?lOEpAA`@?`@A~@Ax@AzACtBI`BIvBOhBQbBU`AOpB[VGHCHCb@In@M|Ac@~@W@AhBk@p@S~@]n@Wf@U~@_@XMf@U\\OrAq@tAq@n@]v@a@tCuAx@a@|Au@h@Y|Au@hJsENInCsAdAg@^Qn@WVKVIh@Q\\Ir@QVCf@IRC`AIb@C\\A~AGvCGfBEv@AdBE|BGdCGlCGtCI~CIn@EdCGzAETARAF?D?~@C`BEzAE`ACj@ELA^CPCj@INANCp@Oh@Oh@OZKhAc@\\MdAa@z@_@vB{@jEeBjAa@`Bq@zCkAlBw@pCgAj@SnAc@b@Mf@Mn@O|@StAWb@GTEbAMtAQzAQhAQbFk@~Ca@vAQpBW~Ca@zDe@dCYpNaBtEm@zCa@jGy@nEk@~B[xEk@jBW`Fm@fLwApB]vAY^K^Kn@StHgCdEwA`Cy@r@U@At@ULEjEwA|@YbA]tDoAZKtBs@lC{@`@OpAg@NGZOf@URMFCLId@Y^Y`@[^]PQLMNQNOPSJMLSNQLSNSJQLUJQJUTe@Tg@HQFQHUFSJYHUX_ANe@HYNk@Ne@Pk@`@qA`@sA`@oA^eAZy@Te@Vi@Ta@Vc@f@u@NS\\c@r@y@h@m@ZYPSb@a@d@_@d@]h@]ZSXORK`@Sl@Uf@Sv@WRGb@KZIREl@Mj@Kl@KbAMl@Gz@Ih@Ch@EvAK~@GpAGdAI~@Gn@CnAIxAIt@G^A`@Er@Gb@EPCD?RCDANAx@Mf@IRE^IXGVGLEv@Wb@MbAa@n@Wt@[h@Uh@Yl@Yh@[p@_@VOZUTOl@a@^[`@[TURO\\]h@g@VW\\]j@m@d@i@h@i@r@s@b@c@X[Z[XYx@w@HI\\Yr@m@LKXWt@m@d@_@^YrB{An@_@jAu@~@k@t@c@~BsAdBcAd@Wt@c@x@e@fAs@NKt@e@h@a@z@o@`@WTSdAy@tBgBtCiCbFmEPQtAoAhAaA|AqAnA_AfAy@fAy@bAq@xCqBXQ??d@g@l@a@|@m@fBoAb@]VYTYNONYLUJYJ[FSJa@Fe@B]By@?UAUAQAQKeAIq@O}AEo@Cs@?w@BqBBkBHsCT{G@o@@k@DkBHaD@k@?WDeANcDF}BDaBA??A?A?AAA@KDyAB}@?C@g@?i@?Y?UAA?K?A?E?A?C?CAAA??AA?A?CA@k@ASCmACg@Cy@G_BCi@Aq@ImBCw@CcACs@Ci@E{ACq@GyAGwBEeAEiACaACo@Ck@CiACu@GeBGaBE}AKkCE}ACm@Ae@AaAAi@@g@?e@@a@?Q@O@m@Bg@HoA@YFm@Do@PuAFm@DWBYBSBYX}BRgBb@yDTkBv@{GD]@OBYj@_FLmAPwALkALcANsA@ONqAPoATuABMLi@L_@BM\\aADKXq@P]FOb@s@HKv@mA@Cv@gAb@o@FKLQXe@HKHMZe@Xa@RYPWXa@R[R]R]N[?AVg@?AXs@Vy@DKJ]FSBMFUBIFY@IHa@Hc@DU@IBMBOBW?AD[B]Du@Ba@Fo@Ds@LyBHkAF{@@ODq@Bg@BQD}@Dk@HkAN_CDq@@GD{@HgABYFiADg@FeA@S^yFDu@h@sIB[PmCN_CrAwSV{DNmCHeAJ_BPkCHoAFcA^yFT{D\\uFN_CNqBlAwQH}APqBJyALaBDi@FkAJeBLgBPeCR{CFw@Da@B_@Fu@Fm@Dc@Fi@NoAJcAHs@Fo@D]Do@Be@@_@?K?e@?c@Ai@AgCA_B?aA@kA@}A??FS@GB]DiADm@@[BSBIBIJQ??Do@Bm@BgABw@?w@C}AAe@AUAIAW?S@k@@I@w@@_@Bk@@o@@W@s@DkBHsCFgAB]Be@??HQ@I@E@G@IRoA??NS@CBABCDCBCBCDABADAFCPCVKNIFCDEFG@CBC@E@EBG@GDSHU@G@GBI@E@C?ABC@ABCLK??\\DjALVBN@z@HNBt@H^F|C\\v@LF@??DCB?D?DAF?B?D@rBLp@Bp@Dr@F~BTlANR@n@JD??@B@@?FHt@DRB|@FrAJ^DTBj@HRB`@F??ZEJ?d@BTBVDb@FtAXfHxAjGlATDvIfBXFPB`@JrB^jAPLBl@FH@H?N@x@?|@@h@@\\Bh@Bd@@TBrHZ`AD`AFxCPpAHRBF@L@XHVHPHNHXPb@Rj@Zb@V^\\TPDBFFVTLJHFDBHDJFTLhAj@fAd@fAf@B@ZRB@DBh@ZlIxEbAj@NJBBXPXPJFDBNH`@Tb@RRJTLx@f@TL^TTD^VVJJDJBD?L?L?JAXGRGHCNGRK??Z@RBXDZF@?\\D@@P@VFPLhAzA`@j@BBj@v@l@r@??\\_AXu@Ts@Vq@Vs@h@wATq@Z{@DMBI@E@E???QAI?GCKCQEUESESKi@AGIc@WgAO_Ac@yB???AI_@?EAE?EAC?E?E?G?O?A?C?C?I@G@G?G^eANe@Z}@`@oAH[BIBK@GBU@O@Q??sCkA??i@bBc@xAm@fBy@]A?CAA?A?A?A?A?A?"

      var decode = google.maps.geometry.encoding.decodePath(p1);

      var rota = new google.maps.Polyline({
        path: decode,
        geodesic: true,
        strokeColor: '#FF0000',
        strokeOpacity: 0.6,
        strokeWeight: 2
      });

      rota.setMap(vm.map);

    },

    discoveryTolls(result){
      let pointsLeg = []; //pontos de cada trecho
      let pointsGoogle = []; //pontos no formato do google para salvar a rota e exibir posterioemente
      let legs = result.routes[0].legs;

      let totalRoute = 0;
      let totalDuration = 0;
      let sequence = 1;
      //itera todos os pontos que compoem a rota
      for (var i = 0; i < legs.length; i++) {
        pointsLeg[i] = [];
        totalRoute += legs[i].distance.value;
        totalDuration += legs[i].duration.value;
        for (var j = 0; j < legs[i].steps.length; j++) {
          for (var k = 0; k < legs[i].steps[j].path.length; k++) {
            var p = legs[i].steps[j].path[k];
            pointsLeg[i].push([p.lng(), p.lat()]);
            p.y = p.lat();
            p.x = p.lng();
            pointsGoogle.push(p);
          }
        }
      }

      let tollsDirection = [];
      let totalTolls = 0;
      for(var leg=0; leg<pointsLeg.length; leg++) {
        let points = pointsLeg[leg];

        let line = turf.lineString(points);//rota

        let tolls = [];//pedagios a x kilometros da rota
        let all = this.all;
        for(var i=0; i<all.length; i++){
          let p = turf.point([all[i].lng, all[i].lat]);
          let d = pointToLineDistance(p, line, {units: 'kilometers'});
          //let pl = turf.pointOnLine(line, p);
          //all[i].pointOnLine = pl;
          if(d * 1000 < all[i].radius){

            all[i].dist = d;
            tolls.push(all[i]);
          }
        }

        const setPegadios = new Set();
        for (let j = 1; j < points.length; j++) {
          for (var i = 0; i < tolls.length; i++) {
            let sc = turf.distance(this.toTurfPoint(tolls[i]), points[j]);
            if (sc < 0.1) {
              setPegadios.add(tolls[i]);
            }
          }
        }

        let sequence = 0;
        setPegadios.forEach(function (value) {
          for (let i = 0; i < tolls.length; i++) {
            if (
              tolls[i].associateId == value.associateId &&
              tolls[i].entryId == value.entryId
            ) {
              tolls[i].sequence = sequence++
            }
          }
        });

        tolls.sort(function (a, b) {
          return a.sequence > b.sequence ? 1 : b.sequence > a.sequence ? -1 : 0;
        });

        for(var i=0; i<tolls.length; i++){


          let p = 0; // ponto da rota mais proximo
          let menorDistancia = 200; // menor distancia
          for(let j=1; j<points.length; j++){
            let auxD = turf.distance(this.toTurfPoint(tolls[i]), points[j]);
            if(auxD < menorDistancia){
              p = j;
              menorDistancia = auxD;
            }
          }


          let pontoAntesDoPedagio = points[p-1];
          let direction = tolls[i].direction;
          //var angle = turf.bearing(pontoAntesDoPedagio, this.toTurfPoint(tolls[i]));
          var angle = turf.bearing(pontoAntesDoPedagio, turf.pointOnLine(line, this.toTurfPoint(tolls[i])));


          if (direction == "A"
              || (direction == "N" && (angle >= -90 && angle <= 90))
              || (direction == "S" && (angle <= -90 || angle >= 90))
              || (direction == "L" && (angle >= 0 && angle <= 180))
              || (direction == "O" && (angle >= -180 && angle <= 0))) {

              tolls[i].angle = angle;
              tolls[i].distanciaPedagioPontoAnterior = turf.distance(this.toTurfPoint(tolls[i]), pontoAntesDoPedagio);
              //tollsDirection.push({lat: pontoAntesDoPedagio[1], lng: pontoAntesDoPedagio[0]});
              tollsDirection.push(tolls[i]);

          }

        }
      }

      return {tolls: tollsDirection, totalRoute: totalRoute, totalDuration: totalDuration};

    },

    toTurfPoint(obj){
      return [obj.lng, obj.lat];
    },

    addPoint(){

      if(this.locationPoints.length < 900){
        this.locationPoints.splice(this.locationPoints.length-1, 0, {sequence: this.locationPoints.length, type: 'waypoint'});
        this.viaPoints = [];
      }

        this.$nextTick(() => {
        const scrollContainer = this.$refs.scrollContainer;
        scrollContainer.scrollTop = scrollContainer.scrollHeight;
      });
    },

    removePoint(i){
      if(this.locationPoints.length > 0) {
        this.locationPoints.splice(i, 1);
        this.viaPoints = [];
      }
    },

    placeChanged(){
      // Chamado quando o usuário digita em algum campo de endereço
    },

    getFirstPlace2(address){
      let vm = this;
      let promise = new Promise(function(resolve, reject) {
        var service = new google.maps.places.AutocompleteService();
        service.getPlacePredictions({
            input: address,
            componentRestrictions: {
                country: 'br'
            }
        }, function(results, status) {
              resolve(results[0]);
        });

      });
      return promise;
    },

    getFirstPlace(address){
      let vm = this;
      let promise = new Promise(function(resolve, reject) {
        var placesService = new google.maps.places.PlacesService(document.getElementById('test'));
        placesService.getDetails(
            {'reference': "Araraquara"},
            function detailsresult(detailsResult, placesServiceStatus) {
                // Here's the first result in the AutoComplete with the exact
                // same data format as you get from the AutoComplete.


            }
        );
      });
      return promise;
    },

  },
  components: {inputAc}
}



// WEBPACK FOOTER //
// ./src/pages/account/routing/routing-mixin.js